import script from "./control.vue?vue&type=script&setup=true&lang=ts"
export * from "./control.vue?vue&type=script&setup=true&lang=ts"

import "./control.vue?vue&type=style&index=0&id=7aa5fe6c&scoped=true&lang=scss"

import exportComponent from "/Users/123imac-49/Desktop/123-chat/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7aa5fe6c"]])

export default __exports__